(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('cgBusy', cgBusy);

    function cgBusy($rootScope, cgbusyService) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs, ctrl) {
                if(scope.vm){
                    attrs.cgBusy = "{ promise: vm.dataPromises }";
                } else{
                    attrs.cgBusy = "{ promise: dataPromises }";
                }

                $rootScope.$on('dataPromisesChanged', function(){
                    if(scope.vm) {
                        scope.vm.dataPromises = $rootScope.dataPromises;
                    } else {
                        scope.dataPromises = $rootScope.dataPromises;
                    }
                });                
            }
        };
    }  
})();